import React, { useContext } from "react";

import TituloPagina from "../../components/comunes/TituloPagina";
import { DarkModeContext } from "../../context/DarkModeContext";
import CrmPostventaV2AlertCenter from "./CrmPostventaV2AlertCenter";

export default function CrmPostventaAlertasV2Page({ showTitle = true }) {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      {showTitle ? <TituloPagina title="CRM Postventa" /> : null}
      <CrmPostventaV2AlertCenter darkMode={darkMode} />
    </>
  );
}
